import Vue from 'vue';
import VueI18n from 'vue-i18n';
import pt from '@/language/pt';
import en from '@/language/en';
import es from '@/language/es';

Vue.use(VueI18n);

const messages = {
  pt,
  en,
  es,
};

const LOCALE_STORAGE_KEY = 'studio_i18n_locale';

function detectInitialLocale() {
  try {
    return localStorage.getItem(LOCALE_STORAGE_KEY) || 'pt';
  } catch {
    return 'pt';
  }
}

const i18nInstance = new VueI18n({
  locale: detectInitialLocale(),
  fallbackLocale: 'en',
  messages,
});

export default i18nInstance;
